import vert from './glsl/videotexture.vert.glsl';
import frag from './glsl/videotexture.frag.glsl';
export default { frag, vert };